/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestTargetResponse } from '../../models/harvest-target-response';

export interface GetTargets$Params {
  harvestId: number;
}

export function getTargets(http: HttpClient, rootUrl: string, params: GetTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestTargetResponse>> {
  const rb = new RequestBuilder(rootUrl, getTargets.PATH, 'get');
  if (params) {
    rb.query('harvestId', params.harvestId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestTargetResponse>;
    })
  );
}

getTargets.PATH = '/api/metric-target';
